module.exports = __webpack_public_path__ + "static/img/about-bg.a4fb8642.png";